module.exports = __webpack_public_path__ + "img/A低通100.3f3a17f1.png";